import { $api } from "../AxiosInstance";

export class AnalyticsService {
  /** page з 0 (як у useTableUpdated) */
  static async getGa4HistoryOrders(params) {
    return await $api.post("/api/admin/ga4/request/history/query", params);
  }

  static async getGa4HistoryById(id) {
    return await $api.get("/api/admin/ga4/request/history/byId", {
      params: { id },
    });
  }

  /** CSV за фільтрами таблиці */
  static async exportGa4History(params) {
    return await $api.post("/api/admin/ga4/request/history/export", params, {
      responseType: "blob",
    });
  }
}
